<template>
    <template v-if="flag == 0">
        <div class="empty mb-0 mt-2" :style="position">
            <!-- <i class="las la-cloud-meatball"></i> -->
            <img :src="emptyPng" style="width: 120px;" />
            <p class="text-center p-0 m-0" style="font-size: 13px;">{{ content? content: getLangValue('base.empty') }}</p>
        </div>
    </template>
    <template v-else-if="flag == 1">
        <div class="empty">
            <img :src="emptyPng" style="width: 120px;" />
            <!-- <i class="las la-cloud-meatball"></i> -->
            <p class="text-center p-0 m-0" style="font-size: 13px;">{{ content? content: getLangValue('base.empty') }}</p>
        </div>
    </template>
    <template v-else-if="flag == 2">
        <div class="empty">
            <p class="text-center p-0 m-0" style="font-size: 13px;">{{ content? content: getLangValue('base.empty') }}</p>
        </div>
    </template>
</template>

<script>
// import emptyPng from "@/assets/images/empty/empty.png"
import emptyPng from "@/assets/images/svg/empty.svg"
import { getLangValue } from "@/utils/common"; //获取后端语言
export default {
    data() {
        return {
            emptyPng: emptyPng
        };
    },
    props: {
        content: {
            type: String,
            default: '',
        },
        position: {
            type: Object,
            default: () => { },
        },
        flag: {
            type: Number,
            default: 0
        }
    },
    methods: {getLangValue,},
    components: {},
};
</script>

<style scoped lang="scss">
.empty {
    font-size: 1rem;
    font-weight: 500;
    color: rgba(33, 37, 41, 0.64);
    //position: absolute;
    //top: 50%;
    //left: 50%;
    //transform: translate(-50%, -50%);
    //margin-bottom: 2rem;
    justify-content: center;
    display: flex;
    flex-direction: column;
    align-items: center;

    i {
        font-size: 5rem;
    }
}

.mb {
    margin-bottom: 2rem;
}
</style>
